import type { NavigationOverview } from '@atlassian/jira-router-resources-business-navigation/src/types.tsx';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';

export const getOverviewUrl = (overview: NavigationOverview, routeName?: RouteName) => {
	switch (routeName) {
		case 'classic-business-overview-summary':
		case 'classic-business-summary':
			return `/jira/core/overviews/${overview.id}/summary`;
		case 'classic-business-overview-calendar':
		case 'classic-business-calendar':
			return `/jira/core/overviews/${overview.id}/calendar`;
		case 'classic-business-overview-timeline':
		case 'classic-business-timeline':
			return `/jira/core/overviews/${overview.id}/timeline`;
		default: {
			return `/jira/core/overviews/${overview.id}`;
		}
	}
};
